"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthStorage = void 0;
const ACCESS_TOKEN_KEY = 'accessToken';
const REFRESH_TOKEN_KEY = 'refreshToken';
const EXPIRES_KEY = 'expires';
class AuthStorage {
    _accessToken = null;
    _refreshToken = null;
    _expires = null;
    _storage;
    constructor(storageType) {
        this._storage = storageType === 'sessionStorage' ? sessionStorage : localStorage;
        try {
            this.accessToken = this._storage.getItem(ACCESS_TOKEN_KEY);
            this.refreshToken = this._storage.getItem(REFRESH_TOKEN_KEY);
            this.expires = Number(this._storage.getItem(EXPIRES_KEY));
        }
        catch (error) {
            this.accessToken = null;
            this.refreshToken = null;
            this.expires = null;
        }
    }
    get accessToken() {
        return this._accessToken;
    }
    set accessToken(value) {
        this._accessToken = value;
        try {
            if (typeof value === 'string') {
                this._storage.setItem(ACCESS_TOKEN_KEY, value);
            }
            else {
                this._storage.removeItem(ACCESS_TOKEN_KEY);
            }
        }
        catch (error) { }
    }
    get refreshToken() {
        return this._refreshToken;
    }
    set refreshToken(value) {
        this._refreshToken = value;
        try {
            if (typeof value === 'string') {
                this._storage.setItem(REFRESH_TOKEN_KEY, value);
            }
            else {
                this._storage.removeItem(REFRESH_TOKEN_KEY);
            }
        }
        catch (error) { }
    }
    get expires() {
        return this._expires;
    }
    set expires(value) {
        this._expires = value;
        try {
            if (typeof value === 'number') {
                this._storage.setItem(EXPIRES_KEY, value.toString());
            }
            else {
                this._storage.removeItem(EXPIRES_KEY);
            }
        }
        catch (error) { }
    }
}
exports.AuthStorage = AuthStorage;
